<div style="width: 25px;height: 25px;float: right;position: relative;right: -10px;cursor: pointer;"
     (click)="closeModal()">
    <i class="material-icons icon" style="font-size: 30px;color: #c80000">
        cancel
    </i>
</div>
<mat-dialog-content>
    <form [formGroup]="requestForm">

        <div class="form-group">
            <mat-form-field class="absence-form-field">
                <mat-label>İstek Sınıfı Seçiniz</mat-label>
                <mat-select [(value)]="selectedReqClassId" formControlName="reqClassId" (selectionChange)="reqClassChanged()">
                    <mat-option *ngFor="let reqClass of reqClassList" [value]="reqClass.id">
                        {{reqClass.description}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="requestForm.controls['reqClassId'].hasError('required')">İstek Sınıfı Seçiniz
                </mat-error>
            </mat-form-field>
        </div>

        <div class="form-group" *ngIf="filteredReqTypeList.length > 0">
            <mat-form-field class="absence-form-field">
                <mat-label>İstek Tipi Seçiniz</mat-label>
                <mat-select formControlName="reqTypeId">
                    <mat-option *ngFor="let reqType of filteredReqTypeList" [value]="reqType.id">
                        {{reqType.description}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="requestForm.controls['reqTypeId'].hasError('required')">İstek Tipi Seçiniz
                </mat-error>
            </mat-form-field>
        </div>

        <!-- talep sikayet degil ise calisan secilmeli -->
        <div class="form-group" *ngIf="selectedReqClassId != talepSikayetId">
            <mat-form-field class="absence-form-field">
                <input type="text" placeholder="Çalışan Seçiniz" aria-label="Number" matInput
                       formControlName="employee" [matAutocomplete]="auto">
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let employee of filteredEmployeeList | async" [value]="employee">
                        {{employee.name}} {{employee.surname}}
                    </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="requestForm.controls['employee'].hasError('incorrect')">
                    Çalışan Seçiniz
                </mat-error>
            </mat-form-field>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <div class="form-group">
                    <mat-form-field class="lookup-form-field" style="width: 100%;">
                        <input matInput placeholder="Başlık" formControlName="subject">
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <div class="form-group">
                    <mat-form-field class="lookup-form-field" style="width: 100%;"><textarea style="height: 100px;resize: none;" matInput formControlName="description"
                                  id="description" aria-describedby="description" placeholder="Açıklama"></textarea>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="form-group">
            <input type="file" placeholder="Dosya yükle" (change)="fileProgress($event)" style="width: 100%;overflow: hidden;">
            <div *ngIf="fileUploadProgress">
                <span style="font-weight: bold;">Yükleniyor:</span> {{ fileUploadProgress }}
            </div>
            <div style="margin-top: 5px">
                <button class="btn btn-light" [disabled]="!fileData"  (click)="uploadFile()">Yükle</button>
            </div>
            <div style="margin-top: 5px" *ngFor="let file of fileList;let i = index;">
                <div class="filename-wrapper">
                    <a style="width: 100px;max-width: 100px;">
                        {{file.fileName}}
                    </a>
                    <i class="material-icons icon" style="color: #c80000;margin-left: 5px;cursor: pointer" (click)="deleteFile(i)">
                        delete
                    </i>
                </div>
            </div>
        </div>

        <button type="submit" class="btn btn-primary" (click)="createOrUpdateAbsence()"
                [disabled]="!requestForm.valid">{{submitButtonName}}</button>
    </form>
</mat-dialog-content>
